import axios from 'axios';

// HELPERS
import { getHeaders } from '../helpers/serviceHelper';

// CONSTANTS
import { apiUrls } from './urls';

export default class PageService {
    static get = (primaryPath, secondaryPath) => {
        return axios.get(apiUrls.getPageUrl(primaryPath, secondaryPath),
            {
                headers: getHeaders()
            });
    };
}